import * as React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import _ from 'lodash';

class Link extends React.Component {
    render() {
        const children = this.props.children;
        let prop = _.omit(this.props, ['children']);
        return /^https?:\/\//.test(this.props.to) ? (
            <a href={prop.to} {...prop}>
                {children}
            </a>
        ) : (
            <RouterLink {...prop}>{children}</RouterLink>
        );
    }
}

export default Link;
